import React from 'react';
import classNames from 'classnames';
import styles from './ActionCard.scss.js';

let ActionCardVariant = /*#__PURE__*/function (ActionCardVariant) {
  ActionCardVariant["SMALL"] = "small";
  ActionCardVariant["MEDIUM"] = "medium";
  ActionCardVariant["LARGE"] = "large";
  return ActionCardVariant;
}({});

/**
 * Props for the ActionCard component.
 */

const ActionCard = _ref => {
  let {
    imageSource,
    alt,
    variant = ActionCardVariant.MEDIUM,
    title,
    description,
    onSelected
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container)
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames(styles.container__content, {
      [styles[`container__content--small`]]: variant === ActionCardVariant.SMALL,
      [styles[`container__content--medium`]]: variant === ActionCardVariant.MEDIUM,
      [styles[`container__content--large`]]: variant === ActionCardVariant.LARGE
    }),
    onClick: onSelected
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container__content__svg)
  }, /*#__PURE__*/React.createElement("img", {
    src: imageSource,
    alt: alt || title,
    className: classNames({
      [styles[`container__content__svg--small`]]: variant === ActionCardVariant.SMALL,
      [styles[`container__content__svg--medium`]]: variant === ActionCardVariant.MEDIUM,
      [styles[`container__content__svg--large`]]: variant === ActionCardVariant.LARGE
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container__content__text)
  }, /*#__PURE__*/React.createElement("h3", {
    className: classNames(styles.container__content__text__title)
  }, title), /*#__PURE__*/React.createElement("p", {
    className: classNames(styles.container__content__text__subtitle)
  }, description))));
};
var ActionCard$1 = ActionCard;

export { ActionCardVariant, ActionCard$1 as default };
//# sourceMappingURL=ActionCard.js.map
